import { ActionIntegration } from '../../../domain/ActionIntegration'
import { FULFILLED } from '../action-helper'
import { ActionIntegrationState } from './ActionIntegrationState'
import { FETCH_ACTION_INTEGRATIONS, FETCH_ACTION_INTEGRATIONS_FOR_TRACE_BOOSTS } from './actions'

const initialState: ActionIntegrationState = {
    byId: {},
    byTracepointServiceEnvironment: {},
    loaded: false,
}

export const actionIntegrationsReducer = (state: ActionIntegrationState = initialState, action: any): ActionIntegrationState => {
    switch (action.type) {
        case FULFILLED(FETCH_ACTION_INTEGRATIONS):
            return { ...state, byId: addIntegrations(action.payload), loaded: true }
        case FULFILLED(FETCH_ACTION_INTEGRATIONS_FOR_TRACE_BOOSTS): {
            const key = `${action.payload.environment}::${action.payload.service}`

            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...addIntegrations(action.payload.data),
                },
                byTracepointServiceEnvironment: {
                    ...state.byTracepointServiceEnvironment,
                    [key]: action.payload.data.map(integration => integration.id),
                },
            }
        }
    }

    return state
}

const addIntegrations = (integrations: ActionIntegration[]): { [key: number]: ActionIntegration } => {
    const byId = {}

    integrations.forEach(integration => {
        byId[integration.id] = {
            ...integration,
            icon: icon(integration.type),
        }
    })

    return byId
}
const icon = (type: string): string => {
    const map = {
        email: 'fa-envelope',
        slack: 'fa-slack',
        hipchat: 'fa-comment-o',
        irc: 'fa-keyboard-o',
    }

    return map[type] || ''
}
